import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";

const mapStateToProps = (state, ownProps) => {
  return {
    isSignedIn: state.auth.token,
    userMigrated: state.auth.userMigrated,
    location: ownProps.path,
    routeProps: {
      exact: ownProps.exact,
      path: ownProps.path
    }
  };
};

function AppRoute(props) {
  const redirectTo = path => (
    <Redirect
      to={{
        pathname: path,
        state: { from: props.location }
      }}
    />
  );

  const renderComponent = () => <props.component {...props} />;

  const render = () => {
    if (props.type === "static") {
      return renderComponent();
    }
    if (props.type === "public") {
      if (props.isSignedIn) {
        return redirectTo("/home");
      } else {
        return renderComponent();
      }
    } else if (props.type === "private") {
      if (props.isSignedIn) {
        return renderComponent();
      } else {
        return redirectTo("/signin");
      }
    }
  };

  return <Route {...props.routeProps} render={() => render()} />;
}

export default connect(mapStateToProps, null, null, { pure: false })(AppRoute);



// WEBPACK FOOTER //
// ./src/app-route.js